$ = require 'jquery'
Backgrounds = require 'app/scripts/data/backgrounds'
Browser = require '@trello/browser'
_ = require 'underscore'
md5 = require 'blueimp-md5'
Promise = require 'bluebird'
{ drawFavicon } = require 'app/scripts/lib/draw-favicon'

module.exports = new class

  constructor: ->
    @settings = {}
    @_update = _.debounce(@_update, 100).bind(@)
    @_hasher = _.memoize md5

  _update: ->
    if !Browser.supportsDynamicFavicon()
      return

    Promise.try =>
      if @settings.url?
        new Promise (resolve, reject) =>
          img = document.createElement('img')
          img.setAttribute('crossorigin', 'anonymous')
          img.onload = -> resolve(img)
          img.onerror = (err) -> reject(err)
          img.src = "#{@settings.url}?favicon"
    .then (img) =>
      href = drawFavicon(img, @settings)
      $('#favicon').remove()
      $('<link>')
      .attr
        id: 'favicon'
        rel: 'icon'
        type: 'image/png'
        sizes: '64x64'
        href: href
      .appendTo('head')
    .catch(->)
    .done()

  setNotifications: (hasNotifications) ->
    @settings.hasNotifications = hasNotifications

    @_update()

  setBackground: ({ url, tiled, color, useDefault }) ->

    @settings.url = url
    @settings.tiled = tiled
    @settings.color = color
    @settings.useDefault = useDefault

    @_update()
